var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"main-button",class:{fullWidth: _vm.isFullWidth, halfWidth: !_vm.isFullWidth},style:(_vm.style),on:{"click":function($event){return _vm.$emit('handleClick')}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }